export default __webpack_public_path__ + "static/media/the_pope_video_es.494eb9a5.svg";